export const CHROME_SPRING = {
  type: "spring" as const,
  stiffness: 220,
  damping: 26,
  mass: 0.9,
};
